import React from 'react';

export const rowSpacingValues = {
    small: 'gap-x-1',
    medium: 'gap-x-4',
    large: 'gap-x-6',
    button: 'gap-x-8 pr-4 py-3',
    header: 'gap-12',
};

export const colSpacingValues = {
    small: 'gap-y-1',
    medium: 'gap-y-3',
    large: 'gap-y-6',
    button: 'gap-y-6 px-4 pb-3',
};

export const paddingValues = {
    small: 'p-3',
    medium: 'p-4',
    large: 'p-6',
    'x-large': 'p-8',
};

export const yPaddingValues = {
    'x-small': 'py-2',
    small: 'py-3',
    medium: 'py-4',
    large: 'py-6',
    'x-large': 'py-8',
};

export const xPaddingValues = {
    'x-small': 'px-2',
    small: 'px-3',
    medium: 'px-4',
    large: 'px-6',
    'x-large': 'px-8',
};

export const cornerRadiusValues = {
    small: 'rounded-sm',
    medium: 'rounded-md',
    large: 'rounded-lg',
};

export const GridContainer = ({
    children,
    className = ''
}) => { 
    return <div className={`grid ${className}`}>
        {children}
    </div>
}

export const RowContainer = ({
    children,
    className,
    spacing,
    padding,
    yPadding,
    xPadding,
    cornerRadius,
    noFlex = false,
    onClick,
}) => {
    return (
        <div
            className={`${!noFlex && 'flex'} ${className} ${rowSpacingValues[spacing]} ${
                padding
                    ? paddingValues[padding]
                    : `${yPaddingValues[yPadding]} ${xPaddingValues[xPadding]}`
            } ${cornerRadiusValues[cornerRadius]}`}
            onClick={() => onClick && onClick()}
        >
            {children}
        </div>
    );
};

export const ColContainer = ({
    children,
    className,
    spacing,
    padding,
    yPadding,
    xPadding,
    cornerRadius,
    noFlex = false,
    onClick,
}) => {
    return (
        <div
            className={`${!noFlex && 'flex flex-col'} ${className} ${colSpacingValues[spacing]} ${
                padding
                    ? paddingValues[padding]
                    : `${yPaddingValues[yPadding]} ${xPaddingValues[xPadding]}`
            } ${cornerRadiusValues[cornerRadius]}`}
            onClick={() => onClick && onClick()}
        >
            {children}
        </div>
    );
};
